<div class="main-container">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card>
      <mat-card-title>Auto Reply Settings</mat-card-title>
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
          Error occurred
        </div>

        <app-mat-text-input [formControl]="getFormControl('name')" label="Schedule Name" name="name"
                            [submitted]="submitted"></app-mat-text-input>
        <app-mat-checkbox-input [formControl]="getFormControl('isEnabled')" label="Enabled" name="isEnabled"
                                [submitted]="submitted"></app-mat-checkbox-input>

        <app-mat-multiselect formControlName="phoneNumbers"
                             placeholder="Type to search phone number"
                             label="Assigned Phone Numbers"
                             name="phoneNumbers"
                             [displayPipe]="phoneNumberDisplayPipe"
                             [lookupDisplayPipe]="phoneNumberDisplayPipe"
                             [submitted]="submitted"
                             [autoCompleteValues]="availablePhoneNumbers"
        >
        </app-mat-multiselect>

        <app-mat-recipients-multiselect [formControl]="getFormControl('recipients')"
                                        placeholder="Search for contacts and tags"
                                        label="Recipients"></app-mat-recipients-multiselect>

        <app-mat-textarea-input [formControl]="getFormControl('replyMessage')" label="Message" name="replyMessage"
                                [submitted]="submitted"></app-mat-textarea-input>

        <h3>Recurrence</h3>
        <app-mat-rrule-form-group [formGroup]="recurringForm" [submitted]="submitted" [userTimezone]="userTimezone"
                                  (onRRuleChanged)="onRRuleChanged($event)"></app-mat-rrule-form-group>
      </mat-card-content>
      <mat-card-actions fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <button type="submit" mat-raised-button color="primary" [promiseBtn]="buttonSubmitPromise"
                *ngIf="hasEditAccess">Save
        </button>
        <button type="button" mat-raised-button color="warn" class="only-icon" matTooltip="Remove automation"
                (click)="onDeleteClick()"
                *ngIf="hasDeleteAccess && model.id && model.id !== 'new'">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
